var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCrystal1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 100 120",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "crystalGrad1a",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#1a1a2e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "50%",
    stopColor: "#0f0f1a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#05050a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "crystalGrad1b",
    x1: "100%",
    y1: "0%",
    x2: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#2a2a40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#12121f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "crystalGrad1c",
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#00D4AA",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#00D4AA",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("filter", {
    id: "crystalGlow1",
    x: "-50%",
    y: "-50%",
    width: "200%",
    height: "200%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#00D4AA",
    floodOpacity: 0.4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", null), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#crystalGlow1)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "50,5 85,60 50,60",
    fill: "url(#crystalGrad1a)"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "50,5 50,60 15,60",
    fill: "url(#crystalGrad1b)"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "50,115 85,60 50,60",
    fill: "url(#crystalGrad1a)",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "50,115 50,60 15,60",
    fill: "#0a0a12"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 50,
    y1: 5,
    x2: 50,
    y2: 115,
    stroke: "#00D4AA",
    strokeWidth: 0.5,
    strokeOpacity: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 15,
    y1: 60,
    x2: 85,
    y2: 60,
    stroke: "#00D4AA",
    strokeWidth: 0.3,
    strokeOpacity: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 50,
    y1: 5,
    x2: 85,
    y2: 60,
    stroke: "#00D4AA",
    strokeWidth: 0.3,
    strokeOpacity: 0.4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 50,
    y1: 5,
    x2: 15,
    y2: 60,
    stroke: "#00D4AA",
    strokeWidth: 0.3,
    strokeOpacity: 0.2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrystal1);
export default __webpack_public_path__ + "static/media/crystal-1.0a91db3ede54cde2b8abf4ebb1e83fcc.svg";
export { ForwardRef as ReactComponent };